"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BannerProductListingSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _productList = require("@ori/product-list");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../../../contexts");
var _constants = require("../../constants");
var _styles = require("../../styles");
var _styles2 = require("../Actions/styles");
var _constants2 = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const BannerProductListingSkeleton = (param)=>{
    let { hasBottomDivider = true } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { isFocusPage } = (0, _contexts.useBannerProductListingContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        isFocusPage: isFocusPage,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
            "data-testid": getTestId(_constants2.BANNER_PRODUCT_LISTING_SKELETON),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Root, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                            variant: "rounded",
                            width: "69px",
                            height: "24px",
                            animation: "pulse"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                            variant: "rounded",
                            width: "137px",
                            height: "24px",
                            animation: "pulse"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_productList.ListSkeleton, {
                    shouldRenderItemCount: true,
                    shouldRenderPagination: true,
                    numberOfItems: _constants.PAGINATION_LIMIT_ITEMS
                }),
                hasBottomDivider ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledDivider, {
                    "data-testid": getTestId(_constants2.BANNER_PRODUCT_LISTING_SKELETON_DIVIDER)
                }) : null
            ]
        })
    });
};
exports.BannerProductListingSkeleton = BannerProductListingSkeleton;
